const getSessionToken = () => {
    return localStorage.getItem('token')!== undefined?JSON.parse(localStorage.getItem('token')):null;
}

const isLoggedIn = () => {
    if (getSessionToken() === '' || !getSessionToken())
        return false;

    return true;
}

const setSessionToken = token => {
    localStorage.setItem('token', token)
}

const setUser = user => {
    localStorage.setItem('user', JSON.stringify(user))
}

const removeSessionToken = () => {
  //  localStorage.removeItem('token');
  //  localStorage.removeItem('user');
}

const redirectIfSessionExpired = (err, history) => {
/*    if (!err) return;
    
    if (err.status && err.status === 'Token is Expired') {
        removeSessionToken();
        history.push('/connexion');
    }*/
}

const getUser = () => {
    return {
        ...JSON.parse(localStorage.getItem('user'))
    }
}

export const Auth = {
    isLoggedIn,
    getSessionToken,
    setSessionToken,
    removeSessionToken,
    redirectIfSessionExpired,
    getUser,
    setUser
}
